import VueRouter from "vue-router"
import home from '../../src/views/Login/login.vue'
// import model1 from '../views/model/model1.vue'
// import model2 from '../views/model/model2.vue'
// import model3 from '../views/model/model3.vue'
import {
  Message
} from 'element-ui'
const router = new VueRouter({
  routes: [
    //配置路由的路径
    {
      path: '',
      redirect:'/moxing'
    },
    {
      path: '/moxing',
      component: home,
      meta: {
        title: '智步云上-3D模型生成平台'
      }
    },
    // {
    //   path: '/HomePage/ZH_Analysis',
    //   name: 'model1',
    //   component: model1,
    // },
    // {
    //   path: '/HomePage/SWOCS_Assets',
    //   name: 'model2',
    //   component: model2,
    // }, 
    // {
    //   path: '/HomePage/3DModCreater',
    //   name: 'model3',
    //   component: model3,
    // },
    {
      path: "*",
      name: "NotFound",
      component: () => import("../views/Error/404.vue"),
    }
  ]
})
// 全局前置守卫
// router.beforeEach((to, from, next) => {

//   // 读取数据
//   let token = localStorage.getItem('token');
//   console.log(token);
//   if (token) { //如果有token，就允许去访问 对应的组件 
//     next(); //放行---页面执行放行操作
//   } else { //如果没有token，就跳转到登录页
//     if (to.path === '/') {
//       next();
//     } else {
//       next('/');
//       Message({
//         message: '请先登录！',
//         type: 'warning'
//       });
//     }
//   }


// })

// 全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;